var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#195DA9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800,251.74c0,139.03-113.17,251.74-252.77,251.74c-25.47,0-83.47-5.86-111.69-29.27l-35.27,35.13 c-20.74,20.65-15.14,26.73-5.91,36.75c3.85,4.18,8.33,9.04,11.79,15.94c0,0,29.39,40.98,0,81.96c-17.64,23.42-67.02,56.2-123.45,0 l-11.76,11.71c0,0,35.27,40.98,5.88,81.96c-17.64,23.42-64.66,46.84-105.81,5.86l-41.15,40.98c-28.22,28.1-62.7,11.71-76.42,0 l-35.27-35.13c-32.92-32.78-13.72-68.3,0-81.96l305.68-304.42c0,0-29.39-46.84-29.39-111.23C294.46,112.71,407.63,0,547.23,0 C686.83,0,800,112.71,800,251.74z M547.24,339.56c48.7,0,88.17-39.32,88.17-87.81s-39.48-87.82-88.17-87.82 c-48.7,0-88.18,39.32-88.18,87.82S498.54,339.56,547.24,339.56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.70706b82be259ba7bc1b315f39411a09.svg";
export { ForwardRef as ReactComponent };